export const formatWithCommas = (value: string) => {
  if (!value) return "";

  const [integer, fraction] = value.split(".");

  const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return fraction !== undefined ? `${formattedInteger}.${fraction}` : formattedInteger;
};
